<script>
export default {
    name: 'SeriesSelectorText',
    props: {
        title: { type: String, default: null },
        question: { type: String, default: null },
    },
    data() {
        return {
            isQuestionInvisible: false,
        };
    },
    watch: {
        question() {
            this.isQuestionInvisible = true;
            setTimeout(() => this.isQuestionInvisible = false, 100);
        }
    }
};
</script>

<template>
    <div>
        <h2 v-if="title" class="step-title" data-test="title">{{ title }}</h2>
        <h3
            v-if="question"
            class="step-question"
            :class="{ 'invisible': isQuestionInvisible }"
            data-test="question"
        >
            {{ question }}
        </h3>
    </div>
</template>